import { initialState } from './reducer';

export default () => state => state.currentUser || initialState;
